/* Omniva parcel-locker picker for the cart. Rendered by snippets/omniva-picker.liquid.
   Plain script on purpose (no theme module imports), so it survives theme updates. */
(function () {
  if (customElements.get('omniva-picker')) return;

  var LANG_FIELD = { LV: 'comment_lav', LT: 'comment_lit', EE: 'comment_est' };
  var CACHE_TTL = 7 * 24 * 60 * 60 * 1000;

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function OmnivaPicker() {
    return Reflect.construct(HTMLElement, [], OmnivaPicker);
  }
  OmnivaPicker.prototype = Object.create(HTMLElement.prototype);
  OmnivaPicker.prototype.constructor = OmnivaPicker;

  OmnivaPicker.prototype.connectedCallback = function () {
    var self = this;
    this.refs = {};
    this.querySelectorAll('[data-ref]').forEach(function (el) { self.refs[el.dataset.ref] = el; });
    this.country = this.dataset.country;
    this.cacheKey = 'omniva-locations-' + this.country;
    this.current = this.dataset.current || '';
    this.items = null;

    this.refs.toggle.addEventListener('change', function () { self.onToggle(); });
    this.refs.input.addEventListener('input', function () { self.renderList(); });
    this.refs.change.addEventListener('click', function () { self.showSearch(); });
    this.refs.list.addEventListener('click', function (e) {
      var b = e.target.closest('[data-id]');
      if (b) self.choose(b.dataset.id);
    });
    this.guard = function (e) { self.guardCheckout(e); };
    document.addEventListener('click', this.guard, true);

    if (this.refs.toggle.checked) this.load();
  };

  OmnivaPicker.prototype.disconnectedCallback = function () {
    document.removeEventListener('click', this.guard, true);
  };

  OmnivaPicker.prototype.onToggle = function () {
    if (this.refs.toggle.checked) {
      this.refs.body.hidden = false;
      this.load();
      this.showSearch();
    } else {
      this.refs.body.hidden = true;
      this.refs.error.hidden = true;
      this.save('');
    }
  };

  OmnivaPicker.prototype.load = function () {
    var self = this;
    if (this.items) return Promise.resolve();
    this.refs.list.innerHTML = '<span class="omniva-picker__loading">' + esc(this.dataset.tLoading) + '</span>';

    var cached = null;
    try {
      var c = JSON.parse(localStorage.getItem(this.cacheKey) || 'null');
      if (c && c.t && Date.now() - c.t < CACHE_TTL && Array.isArray(c.d)) cached = c.d;
    } catch (e) {}
    if (cached) { this.setItems(cached); return Promise.resolve(); }

    return fetch(this.dataset.source)
      .then(function (r) { return r.json(); })
      .then(function (all) {
        var field = LANG_FIELD[self.country] || 'comment_eng';
        var data = all
          .filter(function (x) { return x.A0_NAME === self.country && x.TYPE === '0'; })
          .map(function (x) {
            return {
              id: x.ZIP,
              n: x.NAME,
              c: x.A2_NAME || x.A1_NAME || '',
              a: ((x.A5_NAME || '') + ' ' + (x.A7_NAME || '')).trim(),
              h: x[field] || ''
            };
          });
        try { localStorage.setItem(self.cacheKey, JSON.stringify({ t: Date.now(), d: data })); } catch (e) {}
        self.setItems(data);
      })
      .catch(function () {
        self.refs.list.innerHTML = '<span class="omniva-picker__none">' + esc(self.dataset.tEmpty) + '</span>';
      });
  };

  OmnivaPicker.prototype.setItems = function (data) {
    data.sort(function (p, q) { return p.c.localeCompare(q.c) || p.n.localeCompare(q.n); });
    this.items = data;
    this.renderList();
  };

  OmnivaPicker.prototype.renderList = function () {
    if (!this.items) return;
    var q = this.refs.input.value.trim().toLowerCase();
    var hits = this.items.filter(function (x) {
      return !q || (x.n + ' ' + x.c + ' ' + x.a).toLowerCase().indexOf(q) !== -1;
    }).slice(0, 80);
    if (!hits.length) {
      this.refs.list.innerHTML = '<span class="omniva-picker__none">' + esc(this.dataset.tEmpty) + '</span>';
      return;
    }
    var html = '', city = null;
    hits.forEach(function (x) {
      if (x.c !== city) { city = x.c; html += '<div class="omniva-picker__city">' + esc(city) + '</div>'; }
      html += '<button type="button" class="omniva-picker__item" role="option" data-id="' + esc(x.id) + '">' +
        '<b>' + esc(x.n) + '</b><span>' + esc(x.a) + (x.h ? ' · ' + esc(x.h) : '') + '</span></button>';
    });
    this.refs.list.innerHTML = html;
  };

  OmnivaPicker.prototype.choose = function (id) {
    var x = null;
    for (var i = 0; i < this.items.length; i++) if (this.items[i].id === id) { x = this.items[i]; break; }
    if (!x) return;
    var value = x.n + ', ' + x.a + ', ' + x.c + ' (Omniva ID ' + x.id + ')';
    this.refs.selectedText.textContent = value;
    this.refs.selected.hidden = false;
    this.refs.search.hidden = true;
    this.refs.error.hidden = true;
    this.save(value);
  };

  OmnivaPicker.prototype.showSearch = function () {
    this.refs.selected.hidden = true;
    this.refs.search.hidden = false;
    this.refs.input.focus();
  };

  OmnivaPicker.prototype.save = function (value) {
    this.current = value;
    var attributes = {};
    attributes[this.dataset.attr] = value;
    return fetch(this.dataset.updateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).catch(function () {});
  };

  OmnivaPicker.prototype.guardCheckout = function (e) {
    var btn = e.target.closest('#checkout, button[name="checkout"]');
    if (!btn) return;
    if (this.refs.toggle.checked && !this.current) {
      e.preventDefault();
      e.stopPropagation();
      this.refs.error.textContent = this.dataset.tRequired;
      this.refs.error.hidden = false;
      this.showSearch();
      this.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  };

  if (!customElements.get('omniva-picker')) customElements.define('omniva-picker', OmnivaPicker);
})();